import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import ItemForm from './ItemForm';

function ItemEditModal(props) {
  const { shown, t, item } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [formBusy, setFormBusy] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [item, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="lg"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Save Item')}
        </h5>
        <button
          onClick={() => setModalOpen(false)}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <ItemForm entity={item} onSuccess={onSuccess} onBusyChange={setFormBusy} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => setModalOpen(false)}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="ItemEditForm"
          className="btn btn-primary"
          disabled={formBusy}
        >
          {formBusy ? t('Adding models...') : t('Save Changes')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

ItemEditModal.defaultProps = {
  shown: false,
  item: {},
  onSuccess: () => { },
};

ItemEditModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(ItemEditModal));
